import { Tooltip, TooltipTrigger, TooltipContent } from "@/components/ui/tooltip";
import { HelpCircle } from "lucide-react";

interface InfoTipProps {
  content: string;
  side?: "top" | "right" | "bottom" | "left";
  className?: string;
}

export default function InfoTip({ content, side = "top", className = "" }: InfoTipProps) {
  return (
    <Tooltip delayDuration={200}>
      <TooltipTrigger asChild>
        <button
          type="button"
          className={`inline-flex items-center justify-center rounded-full text-muted-foreground/50 hover:text-muted-foreground transition-colors focus:outline-none ${className}`}
          aria-label="More info"
        >
          <HelpCircle className="w-3.5 h-3.5" />
        </button>
      </TooltipTrigger>
      <TooltipContent
        side={side}
        className="max-w-[280px] bg-[#1A1A1A] text-white text-xs leading-relaxed px-3 py-2 font-normal rounded-lg shadow-lg"
      >
        {content}
      </TooltipContent>
    </Tooltip>
  );
}
